<template>
  <div>
    <!-- v-if="$route.meta.tabShow" -->
    <div v-show="true" v-if="$route.meta.tabShow">
      <van-tabbar route active-color="#DB1905">
        <van-tabbar-item v-for="(item, index) of tabbar" :key="index" replace :to="item.path" :name="index">
          <span>{{ item.meta.name }}</span>
          <template #icon="props">
            <img :src="props.active ? item.icon.active : item.icon.inactive" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import { Tabbar, TabbarItem } from "vant";
import tabbar from '../router/routes/tabbarRoute'
export default {
  name: 'Tabber',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data () {
    return {
      active: 0,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true,
      tabbar,
    };
  },
  mounted () {
    window.onresize = () => {
      if (this.clientHeight > document.documentElement.clientHeight) {
        this.showBtn = false;
      } else {
        this.showBtn = true;
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.van-tabbar {
  height: 1rem;
}
</style>